import {css, Typography, useTheme} from '@mui/material';
import {
  DlMuiChipButton,
  DLMuiTextButton,
  GetStylesFunction,
} from '@wallaby-ui/core';
import {SortModelItem} from 'ag-grid-community';
import {isEmpty} from 'lodash';
import * as React from 'react';
import {useEffect, useMemo, useState} from 'react';
import {FormattedMessage} from 'react-intl';

import {isListFilteredFunction} from '../filtering_helpers';
import {Filter} from 'src/js/lib/filtering';
import {FilterNode} from 'src/js/model/filters_config';

interface OwnProps {
  handleRemoveAllFilters: () => void;
  handleResetSorting: () => void;
  count?: number;
  selectedFilters: Filter[];
  defaultValueFilters: FilterNode[];
  currentSort: SortModelItem[] | undefined;
  areButtonsOutlined?: boolean;
}

type Props = OwnProps;

export const MuiSelectedFilters: React.FC<Props> = (props) => {
  const {
    handleRemoveAllFilters,
    count,
    selectedFilters,
    handleResetSorting,
    currentSort,
    defaultValueFilters,
    areButtonsOutlined,
  } = props;

  const theme = useTheme();
  const styles = getStyles({theme, params: {areButtonsOutlined}});
  const [isListFiltered, setIsListFiltered] = useState(false);

  useMemo(() => {
    setIsListFiltered(
      isListFilteredFunction(selectedFilters, defaultValueFilters)
    );
  }, [selectedFilters, defaultValueFilters]);

  const isListSorted = !isEmpty(currentSort);

  return (
    <div data-name={'mui-selected-filters--wrapper'} css={styles.wrapper}>
      <div data-name={'mui-selected-filters--buttons-wrapper'}>
        {isListSorted ? (
          areButtonsOutlined ? (
            <DlMuiChipButton
              title={'sort.reset.text'}
              css={styles.button}
              onClick={handleResetSorting}
            />
          ) : (
            <DLMuiTextButton
              title={'sort.reset.text'}
              css={styles.button}
              onClick={handleResetSorting}
            />
          )
        ) : null}
        {isListFiltered ? (
          <>
            {areButtonsOutlined ? (
              <DlMuiChipButton
                title={'filter.reset.text'}
                css={styles.button}
                onClick={handleRemoveAllFilters}
              />
            ) : (
              <DLMuiTextButton
                title={'filter.reset.text'}
                css={styles.button}
                onClick={handleRemoveAllFilters}
              />
            )}
            <Typography
              data-name={'mui-selected-filters--search-results-typography'}
              variant={'caption'}
            >
              <FormattedMessage
                data-name={'mui-selected-filters--search-results'}
                id={'common.filters.searchResults'}
                defaultMessage={'of {results}'}
                description={'label Page number'}
                values={{results: <>{count}</>}}
              />
            </Typography>
          </>
        ) : null}
      </div>
      {/* TODO-JK: selected/saved filters */}
      {/* <div>SavedFilters</div> */}
    </div>
  );
};

MuiSelectedFilters.displayName = 'MuiSelectedFilters';

const getStyles: GetStylesFunction = (options) => {
  return {
    wrapper: css`
      width: 100%;
      height: var(--dlSelectedFiltersContainerHeight);
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-bottom: var(--dlSelectedFiltersContainerMarginBottom);
    `,
    button: css({
      marginRight: '8px',
    }),
  };
};
